import type { AxiosInstance } from "axios";
import { apiClient } from "@/data/axiosConfig";

export interface PlaceAutocompleteResult {
  placeId: string;
  text: string;
}

export interface PlaceDetailsResult {
  placeId: string;
  name: string;
  formattedAddress: string;
  primaryType: string;
  postalCode: string;
  postalTown: string;
  country: string;
  countryIso2: string;
}

export interface PlaceSearchRequest {
  query: string;
  placeTypes: string[];
  countries?: string[];
  location?: {
    latitude: number;
    longitude: number;
  };
  sessionToken?: string;
}

export interface PlaceSearchResponse {
  results: PlaceAutocompleteResult[];
}

export interface PlaceDetailsRequest {
  placeId: string;
  sessionToken?: string;
}

export interface PlaceDetailsResponse {
  result: PlaceDetailsResult;
}

export function createPlaceApi(client: AxiosInstance) {
  return {
    search: async (request: PlaceSearchRequest): Promise<PlaceSearchResponse> => {
      const response = await client.post<PlaceSearchResponse>("/api/places/search", request);
      return response.data;
    },
    getDetails: async (request: PlaceDetailsRequest): Promise<PlaceDetailsResponse> => {
      const response = await client.post<PlaceDetailsResponse>("/api/places/details", request);
      return response.data;
    },
  };
}

export const placeApi = createPlaceApi(apiClient);
